import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-text-height-icon',
  templateUrl: './text-text-height.component.html'
})
export class TextTextHeightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
